module.exports = __webpack_public_path__ + "img/gartek-services-plumbing-experienced.be10e8bf.png";